// Importing necessary modules and dependencies
import * as THREE from 'three';
import EventDispatcher from '../common/EventDispatcher';
import {
    Global
} from '../common/global';
import * as CANNON from 'cannon';


// Definition of the GameScene class
export default class GameScene {
    // Constructor takes a scene and camera as parameters
    constructor(scene, camera) {
        this.scene = scene;
        this.camera = camera;

        this.onEvents = this.onEvents.bind(this)
    }

    // Initialization method for setting up event listeners and initial state
    init(gui) {
        this.gui = gui;
        this.events = EventDispatcher.getObj();

        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

    }
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "create_scene":
                this.createScene();
                break;
            case "update":
                this.update(data['message']['data']);
                break;
            case "start_time":
                // this.startTimer();
                break;
            case "dispose":
                this.dispose();
                break;
        }
    }


    createScene() {
        this.addStadium();
    }

    // Method to add a track to the scene based on a given index
    addStadium() {
        // Cloning the road asset from global assets
        this.stadium = Global.assets['glbs'][`stadium`]['asset'].scene.clone();
        this.scene.add(this.stadium);


        this.stadium.traverse((child) => {
            if (!child.material) return false;

            child.material.envMap = Global.envMap;
            child.material.envMapIntensity = 1.3;
        });


        const floorShape = new CANNON.Plane(); // Infinite plane shape
        const floorBody = new CANNON.Body({
            mass: 0, // Mass of 0 makes the body static
            shape: floorShape,
            material: Global.floorMaterial // Use the same material as the ball
        });
        floorBody.position.set(0, 0, 0);
        floorBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2);
        this.scene.world.addBody(floorBody);


        const backSize = {
            w: 4.35,
            h: 1.85
        }
        const sideSize = {
            w: 1.5,
            h: 1.148
        }
        const topSize = {
            w: 4.3,
            h: 1.3
        }
        const planePhysicsHeight = 0.1;
        const planeGeometryBack = new THREE.PlaneGeometry(backSize.w, backSize.h);
        const planeGeometrySide = new THREE.PlaneGeometry(sideSize.w, sideSize.h);
        const planeGeometryTop = new THREE.PlaneGeometry(topSize.w, topSize.h);

        const planeMaterial = new THREE.MeshBasicMaterial({
            color: 0xff0000,
            side: THREE.DoubleSide,
            transparent: true,
            opacity: 0
        });
        const planeBack = new THREE.Mesh(planeGeometryBack, planeMaterial);
        this.scene.add(planeBack);



        const planeLeft = new THREE.Mesh(planeGeometrySide, planeMaterial);
        this.scene.add(planeLeft);

        const planeRight = new THREE.Mesh(planeGeometrySide, planeMaterial);
        this.scene.add(planeRight);

        const planeTop = new THREE.Mesh(planeGeometryTop, planeMaterial);
        this.scene.add(planeTop);

        const planeBottom = new THREE.Mesh(planeGeometryTop, planeMaterial);
        this.scene.add(planeBottom);


        this.planeTop = planeTop;

        const shapeBack = new CANNON.Box(new CANNON.Vec3(backSize.w / 2, planePhysicsHeight / 2, backSize.h / 2));
        this.backBody = new CANNON.Body({
            mass: 0,
            material: Global.netMaterial
        });
        this.backBody.addShape(shapeBack);
        this.backBody.position.set(-1.1, .9, .77);
        this.backBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 0, 0), -Math.PI / 2);
        this.scene.world.addBody(this.backBody);

        const shapeLeft = new CANNON.Box(new CANNON.Vec3(sideSize.w / 2, planePhysicsHeight / 2, sideSize.h / 2));
        this.leftBody = new CANNON.Body({
            mass: 0,
            material: Global.netMaterial
        });
        this.leftBody.addShape(shapeLeft);
        this.leftBody.position.set(1.05, .9, .2);
        this.leftBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 1, 0), Math.PI);
        this.scene.world.addBody(this.leftBody);

        const shapeRight = new CANNON.Box(new CANNON.Vec3(sideSize.w / 2, planePhysicsHeight / 2, sideSize.h / 2));
        this.rightBody = new CANNON.Body({
            mass: 0,
            material: Global.netMaterial
        });
        this.rightBody.addShape(shapeRight);
        this.rightBody.position.set(-3.3, .9, .2);
        this.rightBody.quaternion.setFromAxisAngle(new CANNON.Vec3(1, 1, 0), Math.PI);
        this.scene.world.addBody(this.rightBody);


        const shapeTop = new CANNON.Box(new CANNON.Vec3(topSize.w / 2, planePhysicsHeight / 2, topSize.h / 2));
        this.topBody = new CANNON.Body({
            mass: 0,
            material: Global.netMaterial
        });
        this.topBody.addShape(shapeTop);
        this.topBody.position.set(-1.1, 1.78, .2);
        this.scene.world.addBody(this.topBody);


        const shapeBottom = new CANNON.Box(new CANNON.Vec3(topSize.w / 2, .001, topSize.h / 2));
        this.bottomBody = new CANNON.Body({
            mass: 0,
            material: Global.netMaterial2
        });
        this.bottomBody.addShape(shapeBottom);
        this.bottomBody.position.set(-1.1, 0, .2);
        this.scene.world.addBody(this.bottomBody);




        planeBack.position.copy(this.backBody.position);
        planeBack.quaternion.setFromAxisAngle(new THREE.Vector3(0, 0, 0), -Math.PI / 2);

        planeLeft.position.copy(this.leftBody.position);
        planeLeft.quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2);

        planeRight.position.copy(this.rightBody.position);
        planeRight.quaternion.setFromAxisAngle(new THREE.Vector3(0, 1, 0), -Math.PI / 2);

        planeTop.position.copy(this.topBody.position);
        planeTop.quaternion.setFromAxisAngle(new THREE.Vector3(1, 0, 0), -Math.PI / 2);

        planeBottom.position.copy(this.bottomBody.position);
        planeBottom.quaternion.setFromAxisAngle(new THREE.Vector3(1, 0, 0), -Math.PI / 2);
    }


    // Update method for scene adjustments
    update(data) {


    }
    dispose() {
        // Dispose Three.js objects
        if (this.stadium) {
            this.stadium.traverse((child) => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach((material) => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
            this.scene.remove(this.stadium);
            this.stadium = null;
        }

        // Remove all Cannon.js bodies
        if (this.scene.world) {
            while (this.scene.world.bodies.length > 0) {
                const body = this.scene.world.bodies[0];
                this.scene.world.removeBody(body);
            }

            // Remove all Cannon.js constraints (if any)
            while (this.scene.world.constraints.length > 0) {
                const constraint = this.scene.world.constraints[0];
                this.scene.world.removeConstraint(constraint);
            }
            // this.scene.world.removeEventListener('postStep', yourPostStepFunction);
            // Clear the world (optional, depending on your use case)
            this.scene.world = null;

        }

        // Remove event listeners
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);

        // Force garbage collection (for Chrome, mostly)
        if (window.gc) {
            window.gc();
        }
    }

}